import { useMaintenanceApi } from '../services/api/maintenanceApi';

interface Rol {
  Id: number;
  Nombre: string;
  Activo: boolean;
  Eliminado: boolean;
}

export const useRolesApi = () => {
  return useMaintenanceApi('roles');
};